export const StatusDot = ({ color }) => {
  return (
    <span
      className="blink-dottt"
      style={{
        width: "12px",
        height: "12px",
        borderRadius: "50%",
        backgroundColor: color,
        marginLeft: "6px",
      }}
    />
  );
};